<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="/stucollect">留学汇总</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>入学时间</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item label="年份">
          <el-date-picker
            v-model="query.year"
            type="year"
            value-format="yyyy"
            @change="yearSearch();"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="yearSearch();">查询</el-button>
        </el-form-item>
      </el-form>

      <el-row :gutter="24">
        <el-col :span="12">
          <el-card class="box-card collectCard" shadow="always" style="margin-top:20px;width: 100%;">
            <div class="clearfix" slot="header">
              <span>Vip学生统计</span>
            </div>
            <div class="index-card" style="height:auto;">
              <div id="School" style="height:560px;"></div>
            </div>
          </el-card>
        </el-col>

        <el-col :span="12">
          <el-card class="box-card collectCard" shadow="always" style="margin-top:20px;width: 100%;">
            <div class="clearfix" slot="header">
              <span>Vip学生统计</span>
            </div>
            <div class="index-card" style="height:auto;">
              <div id="School2" style="height:560px;"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/theme/macarons.js";
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {
        year: new Date().getFullYear() + ""
      }, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false
    };
  },
  methods: {
    //获取学校统计，地区统计
    getCollect() {
      //柱状图
      var link2 = url.getCollect("GetAboradTime");
      var link3=url.getCollect("outAboradTime");
      console.log('query:',this.query);
      $.get(link2, this.query, data => {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(
          document.getElementById("School"),
          "macarons"
        );
        // 绘制图表
        myChart.setOption({
          title: {
            text: "入学人数统计",
            subtext: "数据来自Crm系统",
            x: "center"
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            }
          },
          grid: {
            left: "10%",
            right: "10%",
            bottom: "3%",
            containLabel: true
          },
          yAxis: {
            type: "value",
            boundaryGap: [0, 0.01]
          },
          xAxis: {
            type: "category",
            data: data.name.reverse()
          },
          series: [
            {
              name: "申请人数",
              type: "bar",
              barWidth: "40%",
              data: data.value.reverse(),
              label: {
                normal: {
                  show: true,
                  position: "inside"
                }
              }
            }
          ]
        });
      });
        //  退学柱状图
      $.get(link3, this.query, data => {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(
          document.getElementById("School2"),
          "macarons"
        );
        // 绘制图表
        myChart.setOption({
          title: {
            text: "退学人数统计",
            subtext: "数据来自Crm系统",
            x: "center"
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            }
          },
          grid: {
            left: "10%",
            right: "10%",
            bottom: "3%",
            containLabel: true
          },
          yAxis: {
            type: "value",
            boundaryGap: [0, 0.01]
          },
          xAxis: {
            type: "category",
            data: data.name.reverse()
          },
          series: [
            {
              name: "退出人数",
              type: "bar",
              barWidth: "40%",
              data: data.value.reverse(),
              label: {
                normal: {
                  show: true,
                  position: "inside"
                }
              },
              itemStyle: {
      color: 'red' // 设置柱状图的颜色为天蓝色
    }
            }
          ]
        });
      });
    },

    //月份选择
    yearSearch() {
      this.getCollect();
    }
  },
  created() {},
  mounted() {
    this.getCollect();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
